import { HttpContext, HttpContextToken } from '@angular/common/http';

export const SKIP_RS_MESSAGE_HANDLER_ERRORS_TOKEN = new HttpContextToken(() => false);

export const SKIP_RS_MESSAGE_HANDLER_ERRORS_CONTEXT = new HttpContext().set(SKIP_RS_MESSAGE_HANDLER_ERRORS_TOKEN, true);
